import { Grid, Typography } from "@material-ui/core";
import React from "react";
import "./Skills.css";
import Typical from "react-typical";

function Skills() {
  return (
    <div className="skills">
      <h2 className="title">
        {" "}
        <Typical
          loop={Infinity}
          wrapper="b"
          steps={["Programming skills", 9000, "What I know", 9000]}
        ></Typical>
      </h2>
      <div className="max-width">
        <div className="skill-content">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <div className="left">
                <Typography className="text">
                  I have experiences of creating website such as: webblogs,
                  netflix website, E-commerce website, portfolio website and web
                  application. Moreover, I had built a project about register
                  system by using PHP, MySQL and MyAddmin.....
                </Typography>
                <img src="/image/programming4.gif" alt="programming-language" />
              </div>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <div className="right">
                <div className="bars">
                  <div className="info">
                    <span>HTML</span>
                    <span>90%</span>
                  </div>
                  <div className="line html"></div>
                </div>

                <div className="bars">
                  <div className="info">
                    <span>CSS</span>
                    <span>50%</span>
                  </div>
                  <div className="line css"></div>
                </div>

                <div className="bars">
                  <div className="info">
                    <span>Javascript</span>
                    <span>60%</span>
                  </div>
                  <div className="line js"></div>
                </div>

                <div className="bars">
                  <div className="info">
                    <span>PHP</span>
                    <span>60%</span>
                  </div>
                  <div className="line php"></div>
                </div>

                <div className="bars">
                  <div className="info">
                    <span>MySQL</span>
                    <span>70%</span>
                  </div>
                  <div className="line mysql"></div>
                </div>
                <div className="bars">
                  <div className="info">
                    <span>React JS</span>
                    <span>80%</span>
                  </div>
                  <div className="line react"></div>
                </div>
                <div className="bars">
                  <div className="info">
                    <span>C Sharp</span>
                    <span>40%</span>
                  </div>
                  <div className="line csharp"></div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default Skills;
